/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Documents
 */
export interface Documents {
    /**
     * 
     * @type {number}
     * @memberof Documents
     */
    documentId?: number;
    /**
     * 
     * @type {string}
     * @memberof Documents
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Documents
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Documents
     */
    docStoreId?: string;
}

/**
 * Check if a given object implements the Documents interface.
 */
export function instanceOfDocuments(value: object): value is Documents {
    return true;
}

export function DocumentsFromJSON(json: any): Documents {
    return DocumentsFromJSONTyped(json, false);
}

export function DocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Documents {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'status': json['status'] == null ? undefined : json['status'],
        'url': json['url'] == null ? undefined : json['url'],
        'docStoreId': json['docStoreId'] == null ? undefined : json['docStoreId'],
    };
}

export function DocumentsToJSON(json: any): Documents {
    return DocumentsToJSONTyped(json, false);
}

export function DocumentsToJSONTyped(value?: Documents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'status': value['status'],
        'url': value['url'],
        'docStoreId': value['docStoreId'],
    };
}

